import { useContext, useEffect, useState } from "react";
import Campo from "../Campo";
import styles from "./styles.module.css";
import { cepMask, cpfMask, numberMask } from "../../controllers/Masks";
import { useMask } from "@react-input/mask";
import { Membro } from "../../model/Membro";
import VerificaForm from "../../controllers/VerificaForm";
import CampoSenha from "../Campo/CampoSenha";
import listarCidades from "../../services/listarCidades";
import CampoSelect from "../Campo/CampoSelect";
import registrarNovoMembro from "../../services/registrarNovoMembro";
import { UserContext } from "../../context/UserContext";

type Props = {
  listaMembros: Membro[];
  setMembros: React.Dispatch<React.SetStateAction<Membro[]>>;
  closeModal: Function;
};

const AddMembro = ({ listaMembros, setMembros, closeModal }: Props) => {
  const [nomeMembro, setNome] = useState("");
  const [cargoMembro, setCargo] = useState("");
  const [cpfMembro, setCpf] = useState("");
  const [rgMembro, setRg] = useState("");
  const [orgaoMembro, setOrgao] = useState("");
  const [emailMembro, setEmail] = useState("");

  const [cepEndereco, setCep] = useState("79200-000");
  const [numeroEndereco, setNumero] = useState("");
  const [ruaEndereco, setRua] = useState("");
  const [bairroEndereco, setBairro] = useState("");
  const [cidadeEndereco, setCidade] = useState("Aquidauana");
  const [estadoEndereco, setEstado] = useState("MS");
  const [complementoEndereco, setComplemento] = useState("");

  const [novaSenha, setNovaSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");

  const [listaCidades, setListaCidades] = useState(["", "Aquidauana"]);

  const { instituicao_id, token } = useContext(UserContext);

  useEffect(() => {
    const atualizarListaCidades = async () => {
      try {
        const response = await listarCidades(estadoEndereco);
        const cidades = response.map((c: any) => {
          return c.nome;
        });

        setListaCidades(cidades);
        if (estadoEndereco === "MS") {
          setCidade("Aquidauana");
        } else {
          setCidade(listaCidades[0]);
        }
      } catch (error) {
        console.error("Erro ao buscar cidades:", error);
      }
    };
    atualizarListaCidades();
  }, [estadoEndereco]);

  return (
    <form className={styles.formModal}>
      <h2>Adicione um novo Membro</h2>
      <div className={styles.camposDados}>
        <div className={styles.gridCampos}>
          <Campo
            title="Nome"
            type="text"
            placeholder="Nome do membro"
            maxLength={64}
            required={true}
            value={nomeMembro}
            setter={setNome}
            customValidity="Preencha com o nome deste membro"
          ></Campo>
          <Campo
            title="Email"
            type="text"
            placeholder="email_do_membro@email.com"
            maxLength={64}
            required={true}
            value={emailMembro}
            setter={setEmail}
            customValidity="Preencha com o email deste membro"
          ></Campo>
          <Campo
            title="Cargo"
            type="text"
            placeholder="Cargo na Instituição"
            maxLength={64}
            required={true}
            value={cargoMembro}
            setter={setCargo}
            customValidity="Preencha com o cargo deste membro"
          ></Campo>
          <Campo
            title="CPF"
            type="text"
            placeholder="000.000.000-00"
            minLength={14}
            required={true}
            mask={useMask(cpfMask)}
            value={cpfMembro}
            setter={setCpf}
            customValidity="Preencha com o CPF deste membro"
          ></Campo>
          <Campo
            title="RG"
            type="text"
            placeholder="00.000.000"
            maxLength={18}
            required={true}
            value={rgMembro}
            setter={setRg}
            customValidity="Preencha com o RG deste membro"
          ></Campo>

          <Campo
            title="Órgão"
            type="text"
            placeholder="SSP/UF"
            maxLength={8}
            required={true}
            value={orgaoMembro}
            setter={setOrgao}
            customValidity="Preencha com o Órgão expeditor"
          ></Campo>
        </div>

        <hr className={styles.separador} />
        <h3 className={styles.subTitulo}>Endereço da Instituição:</h3>
        <div className={styles.gridCampos}>
          <Campo
            title="CEP"
            type="text"
            placeholder="00000-000"
            minLength={9}
            required={true}
            customValidity="Preencha com o CEP da sua Instituição"
            setter={setCep}
            value={cepEndereco}
            mask={useMask(cepMask)}
          ></Campo>
          <CampoSelect title="Estado" setter={setEstado} value={estadoEndereco}>
            <option value="AC">Acre (AC)</option>
            <option value="AL">Alagoas (AL)</option>
            <option value="AP">Amapá (AP)</option>
            <option value="AM">Amazonas (AM)</option>
            <option value="BA">Bahia (BA)</option>
            <option value="CE">Ceará (CE)</option>
            <option value="DF">Distrito Federal (DF)</option>
            <option value="ES">Espírito Santo (ES)</option>
            <option value="GO">Goiás (GO)</option>
            <option value="MA">Maranhão (MA)</option>
            <option value="MT">Mato Grosso (MT)</option>
            <option value="MS">Mato Grosso do Sul (MS)</option>
            <option value="MG">Minas Gerais (MG)</option>
            <option value="PA">Pará (PA)</option>
            <option value="PB">Paraíba (PB)</option>
            <option value="PR">Paraná (PR)</option>
            <option value="PE">Pernambuco (PE)</option>
            <option value="PI">Piauí (PI)</option>
            <option value="RJ">Rio de Janeiro (RJ)</option>
            <option value="RN">Rio Grande do Norte (RN)</option>
            <option value="RS">Rio Grande do Sul (RS)</option>
            <option value="RO">Rondônia (RO)</option>
            <option value="RR">Roraima (RR)</option>
            <option value="SC">Santa Catarina (SC)</option>
            <option value="SP">São Paulo (SP)</option>
            <option value="SE">Sergipe (SE)</option>
            <option value="TO">Tocantins (TO)</option>
          </CampoSelect>
          <CampoSelect title="Cidade" setter={setCidade} value={cidadeEndereco}>
            {listaCidades &&
              listaCidades.map((cidade, index) => (
                <option value={cidade} key={index}>
                  {cidade}
                </option>
              ))}
          </CampoSelect>
          <Campo
            title="Bairro"
            type="text"
            placeholder="Bairro de sua Instituição"
            maxLength={64}
            required={true}
            customValidity="Preencha com o Bairro da sua Instituição"
            setter={setBairro}
            value={bairroEndereco}
          ></Campo>
          <Campo
            title="Rua"
            type="text"
            placeholder="Rua da sua Instituição"
            maxLength={64}
            required={true}
            customValidity="Preencha com a rua da sua Instituição"
            setter={setRua}
            value={ruaEndereco}
          ></Campo>
          <Campo
            title="Numero"
            type="text"
            placeholder="Numero do Imóvel"
            required={true}
            customValidity="Preencha com o numero do Imóvel"
            setter={setNumero}
            value={numeroEndereco}
            mask={useMask(numberMask)}
          ></Campo>
          <Campo
            title="Complemento"
            type="text"
            placeholder="Complemento do Imóvel"
            maxLength={128}
            required={false}
            customValidity="Preencha com o Complemento"
            setter={setComplemento}
            value={complementoEndereco}
          ></Campo>
        </div>
        <hr className={styles.separador} />
        <h3 className={styles.subTitulo}>Senha do usuário:</h3>
        <div className={styles.gridCampos}>
          <CampoSenha
            title="Senha"
            placeholder="Digite sua senha"
            customValidity="Preencha com sua senha"
            setter={setNovaSenha}
            value={novaSenha}
          />
          <CampoSenha
            title="Confirmar Senha"
            placeholder="Confirme a sua senha"
            customValidity="Confirme a sua senha"
            setter={setConfirmarSenha}
            value={confirmarSenha}
          />
        </div>
      </div>

      <input
        type="submit"
        value="+ Adicionar Membro"
        className={styles.addBtn}
        onClick={(e) => {
          e.preventDefault();
          const adicionarMembro = async () => {
            try {
              await registrarNovoMembro(
                token,
                {
                  cpf: cpfMembro,
                  email: emailMembro,
                  nome: nomeMembro,
                  senha: novaSenha,
                },
                {
                  rg: rgMembro,
                  cargo: cargoMembro,
                  orgao: orgaoMembro,
                  endereco: {
                    cep: cepEndereco,
                    estado: estadoEndereco,
                    cidade: cidadeEndereco,
                    bairro: bairroEndereco,
                    rua: ruaEndereco,
                    numero: numeroEndereco,
                    complemento: complementoEndereco,
                  },
                },
                instituicao_id
              );
            } catch (error) {
              console.log("Erro ao adicionar Membro");
              console.error(error);
            }
          };
          if (VerificaForm(e.currentTarget.form)) {
            adicionarMembro();
            setMembros([
              ...listaMembros,
              {
                nome: nomeMembro,
                cargo: cargoMembro,
                cpf: cpfMembro,
                rg: rgMembro,
                orgao: orgaoMembro,
                email: emailMembro,
                representante: false,
                endereco: {
                  cep: cepEndereco,
                  estado: estadoEndereco,
                  cidade: cidadeEndereco,
                  bairro: bairroEndereco,
                  rua: ruaEndereco,
                  numero: numeroEndereco,
                  complemento: complementoEndereco,
                },
              },
            ]);

            closeModal();
          }
        }}
      />
    </form>
  );
};

export default AddMembro;
